import useLicenseCheck from "license/useLicenseCheck";
const useAgentWorkflowsLicensed = () => {
  const {
    security: { isValid }
  } = useLicenseCheck();
  return isValid;
};
export default useAgentWorkflowsLicensed;
